export default {
  mathTitle: "Enter the answer:",
  regularTitle: "Security code"
};
